import React, { useState } from 'react'
import Marquee from 'react-fast-marquee'
import { LobbyList } from '@/entities/LobbyList/LobbyList'
import jackpots from '@/shared/assets/jackpots.webp'
import { ReactComponent as PlusIcon } from '@/shared/assets/plusIcon.svg'
import { ReactComponent as PinkGlow } from '@/shared/assets/pinkGlow.svg'
import { ReactComponent as Triangle } from '@/shared/assets/orangeTriangle.svg'
import lobbyLines from '@/shared/assets/LobbyLines.webp'
import customJackpot from '@/shared/assets/customJackpot.webp'
import differentJackpot from '@/shared/assets/differentJackpot.webp'
import gamesJackpot from '@/shared/assets/gamesJackpot.webp'
import { classNames } from '@/shared/lib/utils/classNames'
import cls from './GamblingLobby.module.scss'

const JackpotCard = ({ imageSrc, title, description, className }) => {
    return (
        <div className={classNames(cls.JackpotCard, [className])}>
            <img
                src={imageSrc}
                alt={title}
            />
            <h2>{title}</h2>
            <p>{description}</p>
        </div>
    )
}

export const GamblingLobby = () => {
    const [current, setCurrent] = useState(0)
    const jackpotsCards = [
        {
            class: 'featureOne',
            imageSrc: gamesJackpot,
            title: 'Various games',
            description:
                "We offer a variety of games to suit \nevery taste! Whether you prefer \nstrategy, action, or casual fun, there's \nsomething for everyone.",
        },
        {
            class: 'featureTwo',
            imageSrc: customJackpot,
            title: 'Custom Jackpot',
            description: 'Custom jackpots let players set their \nown levels, enhancing engagement \nand satisfaction',
        },
        {
            class: 'featureThree',
            imageSrc: differentJackpot,
            title: 'Different themed backgrounds',
            description: 'Allows to personalize the gaming \nexperience',
        },
    ]

    return (
        <section
            id="gamblinglobby"
            className={cls.GamblingLobby}
        >
            <img
                src={lobbyLines}
                alt=""
                className={cls.lobbyLines}
            />
            <PinkGlow className={cls.pinkGlow} />

            <article className={cls.text}>
                <h1>
                    The Future of
                    <br /> Gambling
                </h1>
                <p>
                    With 20+ years of expertise, 7Stellar blends cutting-edge tech, unique mechanics, and stunning
                    visuals to create games players love and businesses thrive on.
                </p>
                <div className={cls.marqueeContainer}>
                    <Marquee
                        pauseOnHover
                        className={cls.Marquee}
                    >
                        <LobbyList className={cls.lobbyList} />
                    </Marquee>
                    <div className={cls.marqueeShadow} />
                </div>
            </article>
            <article className={cls.image}>
                <img
                    className={cls.slotMachine}
                    src={jackpots}
                    alt="jackpots"
                />
                <div className={cls.shadow} />
                {jackpotsCards.map((card, index) => (
                    <div className={cls[card.class]}>
                        <PlusIcon
                            className={classNames(cls.plusIcon, [], {
                                [cls.active]: index + 1 === current,
                            })}
                            onClick={() => setCurrent((prev) => (prev === index + 1 ? 0 : index + 1))}
                        />
                        <JackpotCard
                            className={classNames(cls[card.class + 'Card'], [], {
                                [cls.active]: index + 1 === current,
                            })}
                            imageSrc={card.imageSrc}
                            title={card.title}
                            description={card.description}
                        />
                    </div>
                ))}
                <Triangle className={cls.triangle} />
            </article>
        </section>
    )
}
